module.exports = __webpack_public_path__ + "static/media/jamesAndMouse.f7c6620c.jpg";